<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <div class="shadow-none">
            <div
              class="d-flex justify-space-between flex-wrap align-center"
            >
              <v-card-title>
                Channel Distributions
              </v-card-title>
              <div class="pa-2">
                <v-btn
                  :disabled="loading"
                  color="primary"
                  @click="newDistribution()"
                >
                  <i class="zmdi zmdi-plus p-r-5" />
                  add
                </v-btn>
              </div>
            </div>
          </div>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :headers="headers"
              :items="distributions"
              class="eg-table-td-py-md"
              disable-pagination
              @click:row="goToDetails"
            >
              <template v-slot:item.id="{item}">
                {{ item.id }}
              </template>
              <template v-slot:item.createTime="{item}">
                {{ moment.utc(item.createTime).format('D MMM YYYY') }}
              </template>
              <template v-slot:item.name="{item}">
                <h6 class="ma-0 font-weight-medium text--pointer">
                  {{ item.name }}
                </h6>
              </template>
              <template v-slot:item.whitelist="{item}">
                {{ item.whitelist.length }}
              </template>
              <template v-slot:item.hls3="{item}">
                <v-btn
                  icon
                  color="warning"
                  @click.stop="openPlayer(item.hls3)"
                >
                  <v-icon>
                    mdi-play
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:item.action="{item}">
                <v-menu
                  left
                  bottom
                >
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon
                        class=""
                      >
                        mdi-dots-horizontal
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click.stop="openRemoveDialog(item)">
                      <v-icon
                        class="text-body-1 mr-2"
                      >
                        mdi-trash-can
                      </v-icon>
                      <v-list-item-title>
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Add Form  -->
    <v-dialog
      v-model="newDistribDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">New Distribution</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                Please provide a name for your distribution (at least three characters):
                <v-text-field
                  v-model="newDistrib.name"
                  label="Name*"
                  :counter="255"
                  :rules="rules.nameRules"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="newDistribDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading || !isFormValid"
            @click="saveNewDistrib()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      :persistent="false"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-l-20 p-r-20">
                {{ channel.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
    <!-- Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete distribution?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the distribution "{{ deletedDistrib.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteDistrib()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { processChannel, processDistribution } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'Distribution List',
    },
    data () {
      return {
        channel: {
          id: 0,
          logo: '',
          name: '',
        },
        headers: [
          {
            text: 'Id',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'Created', value: 'createTime' },
          { text: 'Name', value: 'name' },
          { text: 'Whitelisted IPs', value: 'whitelist' },
          { text: 'HLS3', value: 'hls3', sortable: false },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        distributions: [],
        newDistribDialog: false,
        newDistrib: {
          name: '',
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        frameSrc: '',
        playerDialog: false,
        deletedDistrib: {},
        removeDialog: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.newDistrib.name.length >= 3 && this.newDistrib.name.length <= 255)) {
          return false
        }
        return true
      },
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id) {
          this.getChannelInfo(to.params.id)
        }
      },
    },
    created () {
      const channelId = this.$route.params.id
      this.channel.id = channelId

      this.getChannelInfo(channelId)
    },
    methods: {
      getChannelInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          ids: id,
          expand: 'timezone',
        }
        const channelReq = this.$store.dispatch('channels', args)

        return Promise.all([channelReq])
          .then((res) => {
            const channels = res[0]
            this.channel = processChannel(channels[0])
            this.getDistributions()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'DashboardPage' })
          })
      },
      getDistributions () {
        this.$store.commit('setPageLoader')

        const args = {
          'default[eq]': 0,
          'channel.id[eq]': this.channel.id,
        }
        const distribReq = this.$store.dispatch('distributions', args)

        return Promise.all([distribReq])
          .then((res) => {
            const distributions = res[0]
            const processed = distributions.map((d) => processDistribution(d))
            for (let i = 0; i < processed.length; i += 1) {
              for (const key in processed[i].urls) {
                if (key === 'hls3') {
                  processed[i].hls3 = processed[i].urls.hls3
                }
              }
            }
            this.distributions = processed
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'DashboardPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      goToDetails (distribution) {
        this.$router.push({
          name: 'Distribution',
          params: {
            id: this.channel.id,
            distribution_id: distribution.id,
          },
        })
      },
      newDistribution () {
        this.newDistribDialog = true
      },
      openPlayer (url) {
        this.setFrameSrc(url)
        this.playerDialog = true
      },
      setFrameSrc (url) {
        if (!url) return
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.setFrameSrc('')
      },
      saveNewDistrib () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')
        const distrib = {
          name: this.newDistrib.name,
          channel_id: this.channel.id,
        }

        this.$store.dispatch('createDistribution', distrib)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution has been successfully created',
              timeout: 3000,
              color: 'success',
            })
            this.getDistributions()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.newDistribDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openRemoveDialog (distrib) {
        this.deletedDistrib = distrib
        this.removeDialog = true
      },
      deleteDistrib () {
        if (!this.deletedDistrib.id) return

        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteDistribution', this.deletedDistrib.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.getDistributions()
            this.deletedDistrib = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
    },
  }
</script>

<style>
</style>
